document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.crossSellBazySlider .categorySlider__slider').forEach(slider => {
    // Pomijamy, jeśli już zamontowany
    if (slider.classList.contains('is-mounted')) return;

    const splide = new Splide(slider, { 
      arrows: true,
      pagination: false,
      gap: '16px',
      perPage: 5,
      autoWidth: true,
      arrowPath: 'M 1.816406 21.816406 L 33.792969 21.816406 L 27.804688 27.804688 C 27.09375 28.515625 27.09375 29.667969 27.804688 30.375 C 28.160156 30.730469 28.625 30.910156 29.089844 30.910156 C 29.554688 30.910156 30.023438 30.730469 30.375 30.375 L 39.46875 21.285156 C 40.175781 20.574219 40.175781 19.425781 39.46875 18.714844 L 30.375 9.625 C 29.667969 8.914062 28.515625 8.914062 27.804688 9.625 C 27.09375 10.332031 27.09375 11.484375 27.804688 12.195312 L 33.792969 18.183594 L 1.816406 18.183594 C 0.8125 18.183594 0 18.996094 0 20 C 0 21.003906 0.8125 21.816406 1.816406 21.816406 Z M 1.816406 21.816406',
      breakpoints: {
        1405: { perPage: 4, pagination: true },
        1080: { perPage: 3 },
        740:  { perPage: 1 },
        500:  { arrows: false }
      }
    });

    splide.mount();
    slider.classList.add('is-mounted');
  });
});